import {
  Box,
  Button,
  Checkbox,
  ListItemText,
  MenuItem,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import FirstLineContainer from "components/common/FirstLineContainer";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import RuleSetFieldSelection from "./RuleSetFieldSelection";
import RuleTable from "./RuleTable";
import { setLoading, setDialog } from "slices/appSlice";
import { useFetchRuleProcesses } from "hooks/useRuleConfigProcess";
import Api from "api";
import { useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { formErrorStrfromObj } from "utils/shared";
function RuleSetForm() {
  const dispatch = useDispatch();
  const theme = useTheme();
  const [processList] = useFetchRuleProcesses();
  const navigate = useNavigate();

  const [name, setname] = useState("");
  const [priority, setpriority] = useState("");
  const [processKeys, setProcessKeys] = useState([]);
  const [inputSelected, setinputSelected] = useState([]);
  const [outputSelected, setoutputSelected] = useState([]);
  const validationFailed =
    !inputSelected.length ||
    !outputSelected.length ||
    !name.length ||
    !processKeys.length ||
    !priority.length;
  const [hideFieldSelection, setHideFieldSelection] = useState(false);
  const selectionSubmit = () => {
    setHideFieldSelection(true);
  };
  const showFieldSelection = () => {
    setHideFieldSelection(false);
  };

  const onSubmit = async (ruleList) => {
    dispatch(setLoading(true));

    const newRuleSet = {
      ruleConfigProcessKeys: processKeys,
      priority,
      ruleConfigRuleSetName: name,
      ruleList,
    };
    try {
      const response = await Api.ruleConfigProcess.saveRuleSet(newRuleSet);

      if (response.status === 200) {
        dispatch(
          setDialog({
            message: "RuleSet saved successfully",
            title: "Success",
          })
        );
      }
      navigate(-1);
    } catch (err) {
      dispatch(
        setDialog({ message: formErrorStrfromObj(err), title: err.message })
      );
    } finally {
      dispatch(setLoading(false));
    }
  };

  return (
    <div>
      <FirstLineContainer>Create RuleSet </FirstLineContainer>

      <div>
        {hideFieldSelection ? (
          <RuleTable
            inputs={inputSelected}
            outputs={outputSelected}
            showFieldSelection={showFieldSelection}
            onSubmit={onSubmit}
          />
        ) : (
          <Box>
            <Stack margin={1} spacing={1} direction={"row"}>
              <TextField
                value={name}
                onChange={(e) => setname(e.target.value)}
                label="RuleSet Name"
                sx={{ m: 1 }}
              />
              <TextField
                value={priority}
                onChange={(e) => {
                  if (!isNaN(e.target.value)) setpriority(e.target.value);
                }}
                label="RuleSet Priority"
                sx={{ m: 1 }}
              />
              <Select
                multiple
                value={processKeys}
                size="small"
                onChange={(e) => setProcessKeys(e.target.value)}
                renderValue={(selected) =>
                  processList
                    .filter((p) => selected.includes(p.ruleConfigProcessKey))
                    .map((p) => p.ruleFlowGroupName)
                    .join(", ")
                }
                sx={{ width: "250px" }}
              >
                {processList.map((p) => (
                  <MenuItem
                    key={p.ruleConfigProcessKey}
                    value={p.ruleConfigProcessKey}
                  >
                    <Checkbox
                      checked={processKeys.indexOf(p.ruleConfigProcessKey) > -1}
                    />
                    <ListItemText primary={p.ruleFlowGroupName} />
                  </MenuItem>
                ))}
              </Select>
            </Stack>
            <RuleSetFieldSelection
              inputSelected={inputSelected}
              outputSelected={outputSelected}
              setinputSelected={setinputSelected}
              setoutputSelected={setoutputSelected}
            />
            <Box>
              <Button onClick={() => navigate(-1)}>Cancel</Button>

              <Button disabled={validationFailed} onClick={selectionSubmit}>
                Submit RuleSet
              </Button>
            </Box>
          </Box>
        )}
      </div>
    </div>
  );
}

export default RuleSetForm;
